import React from "react";
import Formsy from "formsy-react";
import FormSelect from "../../common/controls/Select";
import DiscoverApi from "../../../../api/DiscoverApi";
import { ReasonSpecifDetail as ReasonDetails } from "../../../../configurations/discoverConfigs/reasonCodes";
import { MotiveSpecifDetail } from "../../../../configurations/discoverConfigs/motiveCodes";
import { ActionSpecifDetail as ActionDetail } from "../../../../configurations/discoverConfigs/actionCodes";
import ActionSpecificDetail from "./ActionSpecificDetail";
import ReasonSpecificDetail from "../../newCase/transactionDetail/CreateCaseForms/ReasonSpecificDetail";
import Documents from "../../newCase/transactionDetail/CreateCaseForms/Documents";
import { Spinner } from "../../../common/spinner";
import Toaster from "toastr";
import Util from "../../../../util/util";
import Messages from "../../../../configurations/messages";
import { DiscoverFields } from "../../../../configurations/discoverConfigs/fields";
import { DiscoverConstants } from "../../../../configurations/discoverConfigs/discoverConstants";
import TextInput from "../../common/controls/TextInput";

const initialState = {
  canSubmit: false,
  selectedActionCode: "",
  reasonCodes: [],
  motiveCodes: [],
  formData: {},
  selectedReasonCode: "",
  selectedMotiveCode: "",
  fetchingReasonCodes: false,
  fetchingDuplicateTransactions: false,
  sending: false,
  duplicateTransactions: null,
  fetchingTransacation: false,
  caseUpdateError: null,
  transactionDetail: null,
  caseUpdateObject: null,
  actionCodeUnavailable: false,
  caseSuccessfulResponse: null
};

class CaseUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      formData: props.inboundRequest || {},
      selectedReasonCode:
        props.inboundRequest && props.inboundRequest.reasonCode
          ? props.inboundRequest.reasonCode
          : "",
      selectedMotiveCode:
        props.inboundRequest && props.inboundRequest.disputeMotiveId
          ? props.inboundRequest.disputeMotiveId
          : "",
      selectedActionCode:
        props.inboundRequest && props.inboundRequest.actionCode
          ? props.inboundRequest.actionCode
          : ""
    };
    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onActionCodeChange = this.onActionCodeChange.bind(this);
    this.onReasonCodeChange = this.onReasonCodeChange.bind(this);
    this.onMotiveCodeChange = this.onMotiveCodeChange.bind(this);
    this.createCaseRequestObject = this.createCaseRequestObject.bind(this);
    this.getBase64 = this.getBase64.bind(this);
    this.getDuplicateTransactions = this.getDuplicateTransactions.bind(this);
    this.updateFormState = this.updateFormState.bind(this);
    this.getTransactionDetails = this.getTransactionDetails.bind(this);
  }

  componentDidMount() {
    if (
      this.props.caseDetails &&
      this.props.caseDetails.actionCodes &&
      !this.state.reasonCodes.length
    ) {
      const actionCodes = this.props.caseDetails.actionCodes;
      if (actionCodes) {
        const actionCodesObject = actionCodes.filter(
          actionCode => actionCode.actionCode === this.state.selectedActionCode
        );
        if (actionCodesObject && actionCodesObject.length) {
          this.setState(
            {
              reasonCodes: actionCodesObject[0].reasonCodes
            },
            () => {
              let motiveCodes = [];
              if (
                this.state.reasonCodes &&
                this.state.selectedReasonCode &&
                this.state.selectedMotiveCode
              ) {
                const reasonCodeObject = this.state.reasonCodes.filter(
                  reasonCode =>
                    reasonCode.reasonCode === this.state.selectedReasonCode
                );
                motiveCodes =
                  reasonCodeObject &&
                  reasonCodeObject.length &&
                  reasonCodeObject[0].motiveCodes;
              }
              this.setState({
                ...this.state,
                motiveCodes
              });
            }
          );
        } else {
          this.setState({
            actionCodeUnavailable: true,
            selectedActionCode: "",
            selectedReasonCode: "",
            selectedMotiveCode: ""
          });
        }
      }
    }
  }

  disableButton() {
    this.setState({ canSubmit: false });
  }

  enableButton() {
    this.setState({ canSubmit: true });
  }

  getTransactionDetails(transactionReference) {
    // this.setState({ fetchingTransacation: true });
    DiscoverApi.findDiscoverTransaction(transactionReference)
      .then(response => {
        let data = response.data;
        data = {
          ...data,
          settlementAmount: this.props.caseDetails.settlementAmount
        };
        this.setState(
          {
            transactionDetail: data,
            fetchingTransacation: false
          }
          // () => this.getDuplicateTransactions()
        );
      })
      .catch(error => {
        this.setState({
          fetchingTransacation: false
        });
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_TRANSACTION_SEARCH}`
        ]);
      });
  }

  updateFormState(data) {
    this.setState({
      ...this.state,
      formData: { ...this.state.formData, ...data }
    });
  }

  getDuplicateTransactions() {
    const { caseDetails } = this.props;
    const {
      merchantCode,
      settlementAmount,
      settlementCurrencyCode
    } = caseDetails;

    const { transactionDetail } = this.state;
    const { transactionDate, pan } = transactionDetail;

    let settlementAmountAsFloat = settlementAmount.substring(4);
    settlementAmountAsFloat = parseFloat(
      settlementAmountAsFloat.replace(/,/g, "")
    );

    const duplicateRequestObject = {
      transactionDate,
      pan,
      merchantCode,
      settlementAmount: settlementAmountAsFloat,
      settlementCurrencyCode
    };
    this.setState({ fetchingDuplicateTransactions: true });
    DiscoverApi.getDuplicateTransactions(duplicateRequestObject)
      .then(response => {
        const data = response.data;
        this.setState({
          fetchingDuplicateTransactions: false,
          duplicateTransactions: data
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, null, [
          `${Messages.ERROR_DUPLICATE_TRANSACTIONS}`
        ]);
        this.setState({ fetchingDuplicateTransactions: false });
      });
  }

  onReasonCodeChange(selectedOption) {
    let selectedReasonCode = "";
    let motiveCodes = [];
    if (selectedOption) {
      selectedReasonCode = this.state.reasonCodes.find(
        code => code.reasonCode === selectedOption.reasonCode
      );
      const reasonDetailObject =
        ReasonDetails[
          `reasonDetail${selectedReasonCode && selectedReasonCode.reasonCode}`
        ];
      if (
        selectedReasonCode &&
        reasonDetailObject &&
        (reasonDetailObject.isDuplicate || reasonDetailObject.isRecurrent)
      ) {
        this.getDuplicateTransactions();
      } else {
        this.setState({
          duplicateTransactions: null,
          fetchingDuplicateTransactions: false
        });
      }
    }
    if (
      selectedReasonCode.motiveCodes &&
      selectedReasonCode.motiveCodes.length
    ) {
      motiveCodes = selectedReasonCode.motiveCodes;
    }

    this.setState({
      selectedReasonCode: selectedReasonCode.reasonCode,
      selectedMotiveCode: "",
      motiveCodes,
      formData: {
        ...this.state.formData,
        disputeMotiveId: ""
      }
    });
  }

  onMotiveCodeChange(selectedOption) {
    let selectedMotiveCode = "";
    if (selectedOption) {
      selectedMotiveCode = selectedOption.disputeMotiveId;
      const motiveDetailObject =
        MotiveSpecifDetail[`motiveDetail${selectedMotiveCode}`];
      if (
        selectedMotiveCode &&
        motiveDetailObject &&
        (motiveDetailObject.isDuplicate || motiveDetailObject.isRecurrent)
      ) {
        this.getDuplicateTransactions();
      } else {
        this.setState({
          duplicateTransactions: null,
          fetchingDuplicateTransactions: false
        });
      }
    }
    this.setState({
      selectedMotiveCode
    });
  }

  onActionCodeChange(selectedOption) {
    const value = selectedOption && selectedOption["actionCode"];
    this.actionCode.props.setValue(value);
    this.setState({ selectedActionCode: value });
    if (selectedOption && selectedOption.reasonCodes) {
      this.getTransactionDetails(this.props.caseDetails.transactionReference);
      this.setState({
        reasonCodes: selectedOption.reasonCodes,
        motiveCodes: selectedOption.reasonCodes.motiveCodes || []
      });
    } else {
      this.setState({
        selectedActionCode: "",
        reasonCodes: [],
        motiveCodes: [],
        formData: {},
        selectedReasonCode: "",
        selectedMotiveCode: "",
        duplicateTransactions: null
      });
    }
  }

  getBase64(file, callback) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = callback;
  }

  createCaseRequestObject(formData) {
    const {
      transactionReference,
      caseNumber,
      settlementAmount
    } = this.props.caseDetails;
    const { duplicateTransactions } = this.state;

    let settlementAmountAsFloat;
    if (settlementAmount) {
      settlementAmountAsFloat = settlementAmount.substring(4);
      settlementAmountAsFloat = parseFloat(
        settlementAmountAsFloat.replace(/,/g, "")
      );
    }

    if (formData && !formData[DiscoverFields.disputeAmount.name]) {
      formData[DiscoverFields.disputeAmount.name] = settlementAmountAsFloat;
    }

    const reasonCodeObject =
      ReasonDetails[`reasonDetail${formData["reasonCode"]}`];
    const motiveCodeObject =
      MotiveSpecifDetail[`motiveDetail${formData["disputeMotiveId"]}`];

    const isDuplicateProcessing =
      (reasonCodeObject && reasonCodeObject.isDuplicate) ||
      (motiveCodeObject && motiveCodeObject.isDuplicate);
    const isRecurrentProcessing =
      (reasonCodeObject && reasonCodeObject.isRecurrent) ||
      (motiveCodeObject && motiveCodeObject.isRecurrent);

    let apiBody = {
      transactionReference,
      ...formData
    };

    if (
      duplicateTransactions &&
      duplicateTransactions.length &&
      (isDuplicateProcessing || isRecurrentProcessing)
    ) {
      // let duplicateTransactionReferences = duplicateTransactions;

      /* if (isDuplicateProcessing && formData.originalTransactionReference) {
        duplicateTransactionReferences = duplicateTransactionReferences.filter(
          transaction => {
            return (
              transaction.transactionReference !==
              formData.originalTransactionReference
            );
          }
        );
      } */

      /* duplicateTransactionReferences = duplicateTransactionReferences.map(
        transaction => {
          return transaction.transactionReference;
        }
      ); */

      apiBody = {
        ...apiBody,
        duplicateTransactionReferences: []
      };
    }

    if (apiBody.image) {
      this.getBase64(formData.image, e => {
        apiBody = {
          ...apiBody,
          fileFormat: apiBody.image.type.split("/").pop(),
          base64EncodedImage: e.target.result.split(",").pop()
        };
        this.handleSubmit(apiBody, caseNumber);
      });
    } else {
      this.handleSubmit(apiBody, caseNumber);
    }
  }

  handleSubmit(data, caseNumber) {
    this.setState({ ...this.state, sending: true, caseUpdateError: null });
    let requestId = "";
    let requestTypeCode = "";
    const caseRequest = this.props.caseRequest || this.state.caseUpdateObject;
    if (caseRequest) {
      requestId = caseRequest.id || caseRequest.requestId;
      requestTypeCode = caseRequest.requestTypeCode;
      requestTypeCode = requestTypeCode && requestTypeCode.toLowerCase();
      if (!requestTypeCode) {
        if (
          caseRequest.requestType ===
          DiscoverConstants.CaseRequestTypes.caseCreation
        ) {
          requestTypeCode = "cc";
        } else if (
          caseRequest.requestType ===
          DiscoverConstants.CaseRequestTypes.caseUpdate
        ) {
          requestTypeCode = "uc";
        }
      }
    }
    DiscoverApi.updateCase(data, caseNumber, requestTypeCode, requestId)
      .then(response => {
        Toaster.success(Messages.SUCCESS_CASE_UPDATE);
        this.setState({
          ...this.state,
          ...initialState,
          caseSuccessfulResponse: response.data
        });
        this.refs.caseUpdateForm.reset();
        this.props.getCaseDetails(this.props.caseDetails.caseNumber);
      })
      .catch(error => {
        this.setState({
          ...this.state,
          sending: false,
          caseUpdateError: error.data,
          caseUpdateObject: error.data,
          caseSuccessfulResponse: null
        });
        Util.errorMessageToast(Toaster, error.data.description, [
          `${Messages.ERROR_CASE_UPDATE}`
        ]);
      });
  }

  render() {
    const { caseDetails, caseRequest } = this.props;
    const {
      reasonCodes,
      transactionDetail,
      fetchingDuplicateTransactions,
      fetchingReasonCodes,
      selectedActionCode,
      selectedReasonCode,
      selectedMotiveCode,
      motiveCodes,
      duplicateTransactions,
      formData,
      canSubmit,
      sending,
      caseUpdateError,
      actionCodeUnavailable,
      caseSuccessfulResponse
    } = this.state;

    const valueInParent = condition => {
      return (
        condition.parentValue === Boolean(formData[condition.parentField.name])
      );
    };

    const hideReasonCode = actionCode => {
      const Hide =
        actionCode.hasReasonCode &&
        actionCode.reasonCodeCondtional &&
        !valueInParent(actionCode.reasonCodeCondtional);
      if (Hide) {
        return true;
      }
      return false;
    };

    const showReasonCodes =
      ActionDetail[selectedActionCode] &&
      ActionDetail[selectedActionCode].hasReasonCode &&
      reasonCodes &&
      reasonCodes.length &&
      !hideReasonCode(ActionDetail[selectedActionCode]);

    return (
      <div>
        {actionCodeUnavailable &&
          caseRequest &&
          caseRequest.status ===
            DiscoverConstants.CaseRequestStatus.Declined && (
            <div className="alert alert-danger">
              Initial follow up action{" "}
              {caseRequest.inboundRequest &&
                caseRequest.inboundRequest.actionCode &&
                ActionDetail[caseRequest.inboundRequest.actionCode] && (
                  <strong>
                    (
                    {
                      ActionDetail[caseRequest.inboundRequest.actionCode]
                        .description
                    }
                    )
                  </strong>
                )}{" "}
              is no longer available
            </div>
          )}
        {caseUpdateError === "" && (
          <h4 className="text-danger bold">Something went wrong</h4>
        )}
        {caseUpdateError && (
          <div className="alert alert-danger">
            {!caseUpdateError.errors && (
              <h4 className="bold text-danger">
                Error:{" "}
                {caseUpdateError.description || caseUpdateError.responseMessage}
              </h4>
            )}

            {caseUpdateError.errors &&
              caseUpdateError.errors.map((error, index) => (
                <div key={index}>
                  <p>
                    <strong>
                      {error.fieldName && Util.camelToSentence(error.fieldName)}
                      :
                    </strong>{" "}
                    {error.message}
                  </p>
                </div>
              ))}
          </div>
        )}
        {caseSuccessfulResponse && (
          <div className="alert alert-success">
            <h4 className="bold">{caseSuccessfulResponse.description}</h4>
          </div>
        )}
        <Formsy
          onValidSubmit={this.createCaseRequestObject}
          onValid={this.enableButton}
          onInvalid={this.disableButton}
          onChange={this.updateFormState}
          ref="caseUpdateForm"
          noValidate
        >
          <div className="row">
            {caseDetails.actionCodes && caseDetails.actionCodes.length && (
              <div className="col-sm-4">
                <FormSelect
                  name="actionCode"
                  label="Select an action"
                  options={caseDetails.actionCodes}
                  value={
                    !actionCodeUnavailable ? formData["actionCode"] : undefined
                  }
                  valueKey="actionCode"
                  description={DiscoverFields.actionCode.description}
                  innerRef={c => {
                    this.actionCode = c;
                  }}
                  required
                  onChange={this.onActionCodeChange}
                  labelKey="actionCodeDescription"
                />
              </div>
            )}
          </div>
          {selectedActionCode && (
            <ActionSpecificDetail
              reasonCodes={reasonCodes}
              caseDetails={caseDetails}
              transactionDetails={transactionDetail}
              selectedActionCode={selectedActionCode}
              formData={formData}
            />
          )}

          {showReasonCodes ? (
            <div>
              <Documents formData={formData} />
              <ReasonSpecificDetail
                formData={formData}
                getReasonCodes={this.getReasonCodes}
                motiveCodes={motiveCodes}
                reasonCodes={reasonCodes}
                transactionDetails={transactionDetail || caseDetails}
                fetchingReasonCodes={fetchingReasonCodes}
                selectedMotiveCode={selectedMotiveCode}
                selectedReasonCode={selectedReasonCode}
                onReasonCodeChange={this.onReasonCodeChange}
                onMotiveCodeChange={this.onMotiveCodeChange}
                fetchingDuplicateTransactions={fetchingDuplicateTransactions}
                duplicateTransactions={duplicateTransactions}
                getDuplicateTransactions={this.getDuplicateTransactions}
              />
            </div>
          ) : (
            ""
          )}
          <div className="panel panel-default">
            <div className="panel-body">
              <div className="caseNotes">
                <TextInput
                  name={DiscoverFields.caseNote.name}
                  label={DiscoverFields.caseNote.label}
                  description={DiscoverFields.caseNote.description}
                  validations={{ maxLength: DiscoverFields.caseNote.maxLength }}
                  validationErrors={{
                    maxLength:
                      DiscoverFields.caseNote.maxLength &&
                      `You cannot type more than ${
                        DiscoverFields.caseNote.maxLength
                      } characters`
                  }}
                  required={true}
                  placeHolder={DiscoverFields.caseNote.label}
                  multiline={DiscoverFields.caseNote.maxLength >= 200 && true}
                  formData={formData}
                />
              </div>
            </div>
          </div>

          {caseUpdateError === "" && (
            <h4 className="text-danger bold">Something went wrong</h4>
          )}
          {caseUpdateError && (
            <div className="alert alert-danger">
              {!caseUpdateError.errors && (
                <h4 className="bold text-danger">
                  Error:{" "}
                  {caseUpdateError.description ||
                    caseUpdateError.responseMessage}
                </h4>
              )}

              {caseUpdateError.errors &&
                caseUpdateError.errors.map((error, index) => (
                  <div key={index}>
                    <p>
                      <strong>
                        {error.fieldName &&
                          Util.camelToSentence(error.fieldName)}
                        :
                      </strong>{" "}
                      {error.message}
                    </p>
                  </div>
                ))}
            </div>
          )}
          <button
            className="btn btn-primary pull-right"
            type="submit"
            disabled={!canSubmit || sending}
          >
            {sending ? <Spinner color="#FFF" /> : "Update Case"}
          </button>
        </Formsy>
      </div>
    );
  }
}

export default CaseUpdate;



// WEBPACK FOOTER //
// ./src/components/discover/cases/caseDetail/CaseUpdate.js